export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RESULTS_PER_PAGE = 10;
export const KEY = 'f7967da2-321b-4a65-91c3-e6531ed249d7';
export const MODAL_CLOSE_SEC = 2.5;
